/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.125.1-v202604151332-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise } from 'axios';
import { getAxiosInstance, SeeqAxiosRequestConfig } from '@/requests/axios.utilities';
import { isNil, omitBy } from 'lodash';
import * as qs from 'qs';
import * as models from '../model/models';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';

export class sqHierarchiesApiClass {
 
   constructor() {}

  /**
   * @summary Create a new hierarchy from an Item Table. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createHierarchy(
    body: models.HierarchyInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/hierarchies`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyOutputV1>;
  }

  /**
   * @summary Get a list of hierarchies. This endpoint is experimental and may change in future releases.
   * @param {number} [offset=0] - The pagination offset, the index of the first item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of hierarchies that will be returned in this page of results
   * @param {string} [tableDefinitionId] - ID of the table definition that the hierarchy is created from
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchies(
    {
      offset,
      limit,
      tableDefinitionId
    } : {
      offset?: number,
      limit?: number,
      tableDefinitionId?: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/hierarchies`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit,
        ['tableDefinitionId']: tableDefinitionId
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyOutputListV1>;
  }

  /**
   * @summary Get a hierarchy by ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchy(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/hierarchies/${encodeURIComponent(String(id))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyOutputV1>;
  }

  /**
   * @summary Find a hierarchy node with path nodes by column id and value. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @param {Array<string>} [columnIds]
   * @param {Array<string>} [columnValues]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchyNode(
    {
      id,
      columnIds,
      columnValues
    } : {
      id: string,
      columnIds?: Array<string>,
      columnValues?: Array<string>
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/hierarchies/${encodeURIComponent(String(id))}/node`,

      params: omitBy({
        ['columnIds']: columnIds,
        ['columnValues']: columnValues
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyNodeWithPathOutputV1>;
  }

  /**
   * @summary Get nodes in a hierarchy by ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @param {Array<string>} [columnIds]
   * @param {Array<string>} [columnValues]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getHierarchyNodes(
    {
      id,
      columnIds,
      columnValues
    } : {
      id: string,
      columnIds?: Array<string>,
      columnValues?: Array<string>
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/hierarchies/${encodeURIComponent(String(id))}/nodes`,

      params: omitBy({
        ['columnIds']: columnIds,
        ['columnValues']: columnValues
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyNodeOutputListV1>;
  }

  /**
   * @summary Search for a hierarchy node with path nodes from a scaling table row reference. This endpoint is experimental and may change in future releases.
   * @param {string} scalingTableId - The ID of the Scaling Table being searched
   * @param {string} itemId - The ID of the item being searched for
   * @param {string} rowItemId - The ID the item that identifies the row of a Scaling Table
   * @param {string} [rowDatumId] - The datum ID that along with &#x27;rowItemId&#x27; identifies the row of a Scaling Table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public searchHierarchyNode(
    {
      scalingTableId,
      itemId,
      rowItemId,
      rowDatumId
    } : {
      scalingTableId: string,
      itemId: string,
      rowItemId: string,
      rowDatumId?: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(scalingTableId)) {
      throw new Error("'scalingTableId' parameter required");
    }

    if (isNil(itemId)) {
      throw new Error("'itemId' parameter required");
    }

    if (isNil(rowItemId)) {
      throw new Error("'rowItemId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/hierarchies/node/search`,

      params: omitBy({
        ['scalingTableId']: scalingTableId,
        ['itemId']: itemId,
        ['rowItemId']: rowItemId,
        ['rowDatumId']: rowDatumId
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyNodeWithPathOutputV1>;
  }

  /**
   * @summary Update a hierarchy. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the hierarchy
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateHierarchy(
    body: models.HierarchyInputV1,
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/hierarchies/${encodeURIComponent(String(id))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyOutputV1>;
  }

  /**
   * @summary Validate a hierarchy by ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the hierarchy
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public validateHierarchy(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/hierarchies/${encodeURIComponent(String(id))}/validate`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyValidationOutputV1>;
  }

  /**
   * @summary Validate a hierarchy configuration. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public validateHierarchyInput(
    body: models.HierarchyInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/hierarchies/validate`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.HierarchyValidationOutputV1>;
  }

}


export const sqHierarchiesApi = new sqHierarchiesApiClass();
